import {FaRegEye, FaRegEyeSlash} from "react-icons/fa6";

import Button from "@/components/button/Button.tsx";
import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {DatePicker} from "@/components/datePicker/DatePicker.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {SearchInput} from "@/components/searchInput/SearchInput.tsx";
import {StandardDateRange} from "@/lib/queries/reports.ts";

interface SLAReportsOverviewActionBarProps {
  setQuery: (v: string) => void;
  servicesOnly: boolean;
  setServicesOnly: (v: boolean) => void;
  onRangeChange: (start: Date | null, end: Date | null, fixedRange?: StandardDateRange | null) => void;
  hasGroups: boolean;
  query: string;
  start: Date;
  end: Date;
  fixedRange?: StandardDateRange;
}

export const SLAReportsOverviewActionBar = ({
  hasGroups,
  setQuery,
  servicesOnly,
  setServicesOnly,
  onRangeChange,
  query,
  start,
  end,
  fixedRange,
}: SLAReportsOverviewActionBarProps) => {
  const {user} = useCurrentUserContext();
  return (
    <div className={"d-flex mb-3 gap-2 flex-wrap"}>
      {hasGroups && (
        <>
          <Button variant={"secondary"} onClick={() => setServicesOnly(!servicesOnly)}>
            {!servicesOnly && (
              <>
                <Icon icon={FaRegEyeSlash} /> Hide Groups
              </>
            )}
            {servicesOnly && (
              <>
                <Icon icon={FaRegEye} /> Show Groups
              </>
            )}
          </Button>
          <div className="d-flex">
            <SearchInput value={query} onChange={setQuery} placeholder="Search Groups" autoFocus={query.length > 0} />
          </div>
        </>
      )}
      <DatePicker
        mode={"range"}
        selected={{from: start, to: end}}
        fixedRange={fixedRange}
        timezone={user!.account!.timezone}
        dateFormat={user!.current_date_format}
        placement={hasGroups ? "bottom-end" : "bottom-start"}
        onChange={(date, fixedRange) => {
          onRangeChange(date?.from ?? null, date?.to ?? null, fixedRange);
        }}
        disableFutureDates
        hasPopoverInput
      />
    </div>
  );
};
